<section class="content">
  <div class="card" style="padding: 25px">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
    <div *ngIf="!is_data_available">
      <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="100">
      </mat-progress-spinner>
    </div>
    <div class="row" *ngIf="is_data_available">
      <div class="col" >
        <table class="table table-bordered table-striped">
          <tr style="background: #97cdef;">
            <th>S. No.</th>
            <th>Booth Code</th>
            <th>Delivery Date</th>
            <th>Shift</th>
            <th>Amount</th>
            <th>Order Placed By</th>
            <th>Order Placed@</th>
            <th>Order Deleted By</th>
            <th>Order Deleted@</th>
          </tr>
          
          <tr *ngFor="let data of delete_log_data; let log_index=index">
            <td>{{ log_index + 1 }}</td>
            <td>{{ data['business_code'] }}</td>
            <td>{{ data['delivery_date'] | date }}</td>
            <td>{{ data['session_name'] }}</td>
            <td style="text-align: right;">{{ data['total_cost'] | currency: 'INR' }}</td>
            <td>{{ data['order_by'] }}</td>
            <td>{{ data['ordered_time'] | date : 'MMM d, y, h:mm a' }}</td>
            <td>{{ data['deleted_by'] }}</td>
            <td>{{ data['deleted_time'] | date : 'MMM d, y, h:mm a' }}</td>
          </tr>
        </table>
        <div style="font-size: 36px;" *ngIf="delete_log_data.length == 0">There Is No Log !!!</div>
      </div>
    </div>
  </div>
</section>
